module.exports = __webpack_public_path__ + "media/media/about/barneys-pumps-d768923be7d41798145c1d582c6b111f.png";